import React, { Component } from "react";
import CustomDataTableSearch from "../../../../partials/content/CustomDataTableSearch";
import { getTaxes } from "../../../../services/setup/finance/financeSetupService";
import withGlobalData from "../../common/withGlobalData";
class SearchTax extends Component {
  state = {
    reload: this.props.globalData.reload,
    taxes: [{ taxPercent: 0, taxName: "" }],
  };

  componentDidMount() {
    this.getTaxes();
  }

  componentDidUpdate() {
    const { globalData } = this.props;
    const { reload } = this.state;
    if (globalData.reload !== reload) {
      this.getTaxes();
      this.setState({ reload: globalData.reload });
    }
  }

  async getTaxes() {
    const taxes = [];
    const response = await getTaxes();
    const { data } = response.data;
    for (const tax of data.taxes) {
      taxes.push(tax);
    }
    this.setState({ open: false, taxes });
  }

  render() {
    const { taxes } = this.state;
    const { onSelectTax } = this.props;
    return (
      <CustomDataTableSearch
        data={taxes}
        onRefreshData={() => {
          this.getTaxes();
        }}
        onSelectedData={(rowData, originalEvent) => {
          onSelectTax(rowData);
        }}
        columns={[
          {
            field: "select",
            body: (rowData) => (
              <React.Fragment>
                <button
                  type="button"
                  className="btn btn-label-success btn-sm btn-pill btn-bold"
                  onClick={() => onSelectTax(rowData)}
                >
                  Select <i className="fas fa-angle-double-right"></i>
                </button>
              </React.Fragment>
            ),
          },
          {
            header: "Tax Name",
            field: "taxName",
            body: null,
            sortable: true,
          },
          {
            header: "Tax Precent",
            field: "taxPercent",
            body: null,
            sortable: true,
          },
        ]}
      />
    );
  }
}

export default withGlobalData(SearchTax);
